import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";

import AdminLayout from "Layout/AdminLayout";
import AuthLayout from "Layout/AuthLayout";

import IsLogin from "Common/Globle/IsLogin";
import Spinner from "Common/Globle/Spinner";

import { Toaster } from "react-hot-toast";

// =====================================================
// AUTH ROUTES
// These routes do NOT require login
// =====================================================

const AUTH_ROUTES = new Set([
  "/signin",
  "/signup",
  "/password-reset",
  "/two-step",
  "/lockscreen",
  "/maintenance",
  "/404",
]);

// =====================================================
// ERROR BOUNDARY
// =====================================================

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      "@@@ ErrorBoundary caught:",
      error,
      errorInfo
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 gap-3">
          <h5 className="text-danger">
            Something went wrong.
          </h5>

          <button
            className="btn btn-primary btn-sm"
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

// =====================================================
// RENDER LAYOUT
// =====================================================

const renderLayout = (pathname) => {
  // ===================================================
  // PUBLIC / AUTH ROUTES
  // ===================================================

  if (AUTH_ROUTES.has(pathname)) {
    return <AuthLayout />;
  }

  // ===================================================
  // PRIVATE / ADMIN ROUTES
  // ===================================================

  return (
    <IsLogin>
      <AdminLayout />
    </IsLogin>
  );
};

// =====================================================
// APP
// =====================================================

const App = () => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary>
      <Suspense fallback={<Spinner />}>
        {renderLayout(pathname)}

        <Toaster
          position="top-right"
          reverseOrder={false}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;